import text from "strings/text";
import { useIntl } from 'react-intl';

const { isValidObject } = require("helpers/validation");

const getFullName = (obj) =>  {
    const user = obj.userPrivilege;
    const validFirstName = isValidObject(user.first_name);
    const validLastName = isValidObject(user.last_name);

    if ( validFirstName && validLastName) {
        return `${user.first_name} ${user.last_name}`;
    }else if (validFirstName) {
        return user.first_name;
    }else if (validLastName) {
        return user.last_name;
    }else{
        return '';
    }
} 

const getEmail = (obj) => {
    const user = obj.userPrivilege;
    const validEmail = isValidObject(user.email);
    const validUnconfirmedEmail = isValidObject(user.unconfirmed_email);
    if (validEmail) {
        return user.email;
    }else if (validUnconfirmedEmail) {
        return user.unconfirmed_email;
    }else{
        return '';
    }
}

const getPhone = (obj) => {
    const user = obj.userPrivilege;
    const validPhone = isValidObject(user.phone_number);
    if (validPhone) {
        return user.phone_number;
    }else{
        return '';
    }
}

const getJobTitle = (obj) => {
    const user = obj.userPrivilege;
    const validPosition = isValidObject(user.position);
    if (validPosition) {
        return user.position;
    }else{
        return '';
    }
}

const getEmployeeID = (obj) => {
    const user = obj.userPrivilege;
    const validEmployeeID = isValidObject(user.badge_id);
    if (validEmployeeID) {
        return user.badge_id;
    }else{
        return '';
    }
}

const getAvatar = (obj) => {
    const user = obj.userPrivilege;
    const validProfilePicture = isValidObject(user.profile_image_thumb_url);
    if (validProfilePicture) {
        return user.profile_image_thumb_url;
    }else{
        return '/icons/default-profile-thumb.svg';
    }
}

const getAccessLevelText = (obj) => {
    const user = obj.userPrivilege;
    if( user.is_admin ) {
        return text.adminIntl
    }else{
        return text.teamMemberIntl
    }
}

const getIsAdminFlag = (obj) => {
    const user = obj.userPrivilege;
    if( user.is_admin ) {
        return true
    }else{
        return false
    }
}

const getStatusText = (obj) => {
    const uPriv = obj.userPrivilege;
    console.log(uPriv?.status);

    if( uPriv?.status == 'active' ) {
        return 'Active'
    }else if( uPriv?.status == 'pending' ) {
        return 'Pending'
    }else if( uPriv?.status == 'unregistered' ){
        return 'Unregistered'
    }else{
        return ''
    }
}

const classNamesForHalfField = (isGrayedOut) => {
    return (isGrayedOut ? 'half-field grey-out' : 'half-field')
}

const classNamesForAccessLevelButton = (isInEditMode) => {
    return (isInEditMode ? 'half-field has-down-chevron' : 'half-field')
}

const classNamesForGroupDropdown = (hasOtherGroups) => {
    return (hasOtherGroups ? 'user-group-button has-down-chevron' : 'user-group-button')
}

export default {
   getFullName, 
   getEmail,
   getPhone,
   getJobTitle,
   getEmployeeID,
   getAvatar,
   getAccessLevelText,
   getStatusText,
   getIsAdminFlag,
   classNamesForHalfField,
   classNamesForAccessLevelButton,
   classNamesForGroupDropdown
}